export default {
  'notifications.success.label': 'Success',
  'notifications.success.generic_message':
    'The action performed was successful.',
  'notifications.warning.label': 'Warning',
  'notifications.errors.label': 'Error',
  'notifications.errors.something_went_wrong':
    'Something went wrong. Please try again.',
};
